require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-laura-mirabal.json") })
        }
      }, "path---articles-tags-laura-mirabal");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-laura-mirabal!./.cache/json/articles-tags-laura-mirabal.json
// module id = 1880
// module chunks = 231608221292675